/**
 * Componente: Aviso antes de imprimir un carnet cuyo campo "clases" (formato código + descripción) no entra
 * completo en su caja, ni a la letra mínima de 5 pt: se imprimiría cortado con "…". Hay que confirmar para
 * seguir. Mismo patrón que ConfirmarRenovacionModal (modal propio, nunca el confirm() del navegador).
 */

import React from 'react';
import { IconCerrar, IconAdvertencia } from './icons';

const ConfirmarCorteClasesModal = ({ nombreCompleto, onConfirmar, onCancelar }) => (
  <div className="modal-overlay" onClick={onCancelar}>
    <div className="modal-content confirmar-eliminar-modal" role="alertdialog" aria-modal="true" onClick={(e) => e.stopPropagation()}>
      <div className="modal-header">
        <h2>Revisá antes de imprimir</h2>
        <button className="modal-close" onClick={onCancelar}><IconCerrar size={18} /></button>
      </div>

      <div className="modal-body">
        <div className="alert alert-error">
          <IconAdvertencia size={18} />
          <p><strong>El texto de las clases no entra completo en este carnet.</strong></p>
        </div>
        <p>
          {`Al imprimir el carnet de ${nombreCompleto}, la lista de clases va a salir cortada con "…". Podés cancelar y pedirle al administrador que agrande la caja de las clases en el Diseñador, o imprimirlo así.`}
        </p>
      </div>

      <div className="modal-footer">
        <button type="button" className="btn-cancelar" onClick={onCancelar}>
          Cancelar
        </button>
        <button type="button" className="btn-guardar" onClick={onConfirmar}>
          Imprimir de todos modos
        </button>
      </div>
    </div>
  </div>
);

export default ConfirmarCorteClasesModal;
